import { IntlShape } from 'react-intl';
import { LEDIdentifierOptions } from '../Nodes/types';

export const getLEDText = (
  ledsArray:
    | {
        channel: string;
        identifier: LEDIdentifierOptions[] | null;
        name: string | null;
      }[]
    | null,
) => {
  if (!ledsArray || ledsArray.length === 0) return '';
  return ledsArray.length === 1 ? `${ledsArray[0].name} | ` : 'LEDs | ';
};

export const getActionText = (
  intlInstance: IntlShape,
  isPulse: boolean,
  isRamp: boolean,
  isRampdown: boolean,
  rampdownDuration?: number,
) => {
  if (isPulse) {
    return intlInstance.formatMessage({
      defaultMessage: 'Pulse',
      id: 'DTM010',
    });
  }
  if (isRamp) {
    return intlInstance.formatMessage({
      defaultMessage: 'Fade In',
      id: '/dQrVa',
    });
  }
  if (isRampdown) {
    return rampdownDuration === 0
      ? intlInstance.formatMessage({
          defaultMessage: 'Instant',
          id: '4cdhFd',
        })
      : intlInstance.formatMessage({
          defaultMessage: 'Fade Out',
          id: '0POxKG',
        });
  }
  return intlInstance.formatMessage({
    defaultMessage: 'Default',
    id: 'lKv8ex',
  });
};
